// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"360":"ba83e5e1","422":"4511d56b","762":"a94b682a","833":"eba759d6"}[chunkId] + ".chunk.js";
};